import classes from "./TodoItem.module.css";

const TodoItem = (props) => {
  return (
    <li className={`${classes.todo} ${props.done ? classes.done : ""}`}>
      <span onClick={props.onToggle} className={classes.textContainer}>
        <div className={classes.text}>{props.children}</div>
        {props.createDate && (
          <div className={classes.date}>
            {new Date(props.createDate).toLocaleString('de-DE')}
          </div>
        )}
      </span>
      <button onClick={props.onDelete} className={classes.deleteBtn}>
        X
      </button>
    </li>
  );
};

export default TodoItem;
